module.exports = __webpack_public_path__ + "static/img/CH.d36f792a.svg";